
import PreEntryApi from '../../assets/js/preentry'
import Validate from '../../assets/js/pre_validate'
import OnboardHeader from '../OnboardHeader'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'

import { i18nHelper } from '@it-common/lbp_common'

export default {
components: {
XButton,
Group,
Cell,
XInput,
PopupRadio,
Loading,
Datetime,
Confirm,
OnboardHeader,
XSwitch
},
data () {
return {
country_id: '47206',
no_family: 1,
id: '',
isZH: true,
familyList: [],
showLoading: true,
deleteRowsConfirm: false,
mobileFlag: false,
deleteCurIndex: '',
hasShowPopup: {
data: false
},
birthday: '1960-01-01',
code: '',
is_intern: '',
is_blue_collar: '',
notOnlyOnce: [4, 5, 6, 7, 8, 9, 10, 11],
relation2Items: []
}
},
computed: {
submitName: function () {
return this.$tsg('工作经历')
}















},
watch: {
familyList: {
handler: function (val) {
var relationArray = []
val.forEach(function (item) {
relationArray.push(item.relation)
})
},
deep: true
}
},
created () {
this.id = this.$route.query.id
this.postPsOption()
this.mobileFlag = this.isMobile()

var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')
this.isZH = localStorage.getItem('offer_zh') === 'zh'
i18nHelper.loadLanguagePack(4159)
i18nHelper.setFixedLocale(localStorage.getItem('offer_zh'))
this.$forceUpdate()
if (!this.code || !this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },
data => {
if (data && data.isSubmit === true) {
this.$router.push({ name: 'onboard.preview', query: { id: this.id } })

}
},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
},
() => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},
() => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
)

try {
PreEntryApi.getExperience(
{ id: this.id, getField: 'family_member', code: this.code },
data => {
if (data) {
this.familyList = data
this.familyList.forEach(
function (item, key) {
if (!Validate.isMobile(item.contact_number)) {
this.familyList[key].contact_number_state = false
} else {
this.familyList[key].contact_number_state = true
}
}.bind(this)
)
} else {
this.addFamily()
}
this.showLoading = false
},
code => {
if (code === -1) {
this.addFamily()
}
this.showLoading = false
},
() => {
this.showLoading = false
this.$message.error('数据获取失败。')
},
() => {
this.showLoading = false
this.$message.error('系统内部错误，请联系管理员。')
}
)

PreEntryApi.getStaffDetail({ id: this.id, code: this.code }, data => {
if (data) {
this.birthday = data.birthday
this.country_id = data.country_id ? data.country_id : '47206'
console.log(this.country_id)
}
})
} catch (e) {
this.showLoading = false
this.$message.error('系统内部错误，请联系管理员。')
}

PreEntryApi.getSubmitStatus({ id: this.id }, data => {
if (data) {
if (data.is_intern === 1) {
this.submitName = '培训经历'
}
this.is_intern = data.is_intern
this.is_blue_collar = data.is_blue_collar
}
})
},
mounted () {
i18nHelper.loadLanguagePack(4159)
},
methods: {
isMobile () {
if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
return true
}
return false
},
deleteRows (key) {
this.deleteRowsConfirm = true
this.deleteCurIndex = key
},
sendDel () {
this.familyList.splice(this.deleteCurIndex, 1)
this.sendMaterial(3)
},
contactNumberState (key) {
if (!Validate.isMobile(this.familyList[key].contact_number)) {
this.familyList[key].contact_number_state = false
} else {
this.familyList[key].contact_number_state = true
}
},
changeRelation (key) {
var relationArray = []
this.familyList.forEach(item => {
if (this.notOnlyOnce.indexOf(item.relation) === -1) {
relationArray.push(item.relation)
}
})

if (this.isRepeat(relationArray)) {
this.familyList[key]['relation'] = ''
this.familyList[key]['birthday'] = ''
this.$message.error(this.$tsg('家庭成员不可重复选择。'))
return
}

var birthdayArr = this.birthday.split('-')
var relationVal = this.familyList[key].relation
if (!birthdayArr[0]) {
return
}
if (relationVal === 1 || relationVal === 2) {
this.familyList[key].birthday = parseInt(birthdayArr[0]) - 25 + '-01-01'
}

if (relationVal === 3 || relationVal === 5 || relationVal === 6) {
this.familyList[key].birthday = parseInt(birthdayArr[0]) + '-01-01'
}

if (relationVal === 4) {
this.familyList[key].birthday = parseInt(birthdayArr[0]) + 25 + '-01-01'
}
},
isRepeat (arr) {
let hash = {}
for (let i in arr) {
if (hash[arr[i]]) {
return true
}
hash[arr[i]] = true
}
return false
},
showStep () {
this.hasShowPopup.data = !this.hasShowPopup.data
},
removeFamily () {

this.familyList = []
this.familyList.push({
relation: '',
name: '',
work_unit: '',
profession: '',
birthday: '',
contact_number: '',
insured: false
})

},
addFamily () {
if (this.familyList.length === 5) {
this.$message.error(this.$tsg('家庭成员填写5个以内即可。'))
return false
}
console.log(this.familyList)
this.familyList.push({
relation: '',
name: '',
work_unit: '',
profession: '',
birthday: '',
contact_number: '',
insured: false
})
},

getIsZh (data) {
var localStorage = window.localStorage
if (data) {
localStorage.setItem('offer_zh', 'zh')

} else {
localStorage.setItem('offer_zh', 'en')

}
this.isZH = data
},
changeFamilyStatus () {
this.no_family = this.no_family === 1 ? 2 : 1
if (this.no_family === 2) {
this.familyList = []
PreEntryApi.saveExperience(
{
id: this.id,
code: this.code,
family_member: this.familyList,
saveField: 'family_member'
},
data => {
if (data !== '') {
this.$message.error(this.$tsg('资料信息更新失败。'))
return false
}

},
() => {
this.$message.error(this.$tsg('资料信息更新失败。'))
this.loading = false
}
)
if (this.familyList.length === 0) {
this.addFamily()
}
} else {
if (this.familyList.length === 0) {
this.addFamily()
}
}

PreEntryApi.updateStatusValue(
{
id: this.id,
field: 'no_family',
no_family: this.no_family,
code: this.code
},
() => {
console.log(222)
},
() => {
console.log(333)
this.$message.error(this.$tsg('状态字段更新失败。'))
}
)
},
sendMaterial (returnFlag) {
if (!this.id) {
this.$message.error(this.$tsg('非法操作。'))
return false
}

var familyList = []
for (var family in this.familyList) {
if (!this.familyList[family].contact_number_state) {
this.$message.error(this.$tsg('电话号格式错误'))
return
}
}
this.familyList.forEach(function (item) {
if (item.relation || item.name || item.work_unit || item.profession || item.birthday || item.contact_number) {
familyList.push(item)
}
})

PreEntryApi.saveExperience(
{
id: this.id,
code: this.code,
family_member: familyList,
saveField: 'family_member'
},
data => {
if (data !== '') {
this.$message.error(this.$tsg('资料信息更新失败。'))
return false
}


if (returnFlag === 2) {
this.$router.push({
name: 'onboard.work',
query: { id: this.id }
})
} else if (returnFlag === 1) {
this.$router.push({ name: 'onboard.list', query: { id: this.id } })
} else if (returnFlag === 3) {

}
},
() => {
this.$message.error(this.$tsg('资料信息更新失败。'))
this.loading = false
}
)
},
postPsOption () {
PreEntryApi.postPsOption(
{},
(data, meta) => {
const typeObj = data['7'] || {}
this.relation2Items = Object.keys(typeObj).map(key => ({
key: Number(key),
value: typeObj[key]
}))

this.showLoading = false
},
err => {
this.$message.error(this.$tsg('选项数据获取失败。'))
this.showLoading = false
}
)
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/family.vue